<template lang="pug">
div.row.mx-0.px-1.py-2
  div.w-100.border.rounded-top
    ul.nav.nav-pills.bg-light.p-2.rounded
      li.nav-item.hover-navItems.mr-1.rounded(
        v-for="node in sortedMainNodes"
        @click="selectNode(node)"
      )
        a.nav-link.text-white(
          :class="{ active: node.catid == selectedMainNode.catid, 'text-primary': node.catid != selectedMainNode.catid }",
          :title="node.catid"
        )
          | {{ node.label }}
  div.col-4.p-0.m-0
    div.box-list-filter.py-4.px-2.bg-light(:class="{ 'position-relative': true, 'pe-none': isLoading }")
      div.loading-overlay(v-if="isLoading")
        div.spinner-border.text-primary(role="status")
      ul.list-unstyled.list-origin(
        v-for="catid in Object.keys(tabNodes)"
        v-show="catid == selectedMainNode.catid"
      )
        navigation-index-node-vue(
          v-for="node in tabNodes[catid].nodes"
          :key="node.catid"
          v-bind="node"
          :index="index"
          :selected="selected"
          class="form-check-label"
          @value-selected="valueSelected"
          @loading-changed="onLoadingChanged"
        )
  div.col-8.p-0
    breadcrumb-vue(:breadcrumbs="breadcrumbs" class="bg-secondary rounded-0")
    slot
</template>

<script>
import mixins from 'common/mixins'
import navigation_index_mixin from 'common/mixins/navigation_index'
import { mapMutations, mapActions, mapState } from 'vuex'

export default {
  name: 'navigation-index-main-vue',
  props: {
    index: { type: String, default: '' },
    mainNodes: { type: Array, default: () => [] },
    firstNodeId: { type: Number, default: 0 },
    singleResultsGroup: { type: String, default: '' }
  },
  components: {
    'navigation-index-node-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/navigation_index/Node'
    ),
    'breadcrumb-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/Breadcrumb'
    )
  },
  mixins: [navigation_index_mixin, mixins.filters],
  data: function () {
    return {
      path: [],
      selected: 0,
      selectedMainNode: this.mainNodes[0],
      tabNodes: this.buildTabNodes(),
      isLoading: false
    }
  },
  computed: {
    sortedMainNodes() {
      return [...this.mainNodes].sort((a, b) => {
        const aId = Number(a.catid)
        const bId = Number(b.catid)

        const firstId = Number(this.firstNodeId)
        if (firstId > 0) {
          const aIsFirst = aId === firstId
          const bIsFirst = bId === firstId
          if (aIsFirst && !bIsFirst) return -1
          if (bIsFirst && !aIsFirst) return 1
        }

        return aId - bId
      })
    },
    breadcrumbs() {
      return this.path
    },
    ...mapState('search', ['groupResults'])
  },
  watch: {
    groupResults: {
      handler(newVal) {
        if (this.singleResultsGroup == '') return

        let singleDocument = this.getSingleResultDocument(newVal, this.singleResultsGroup)
        if (!singleDocument) return

        this.setFilters([]) // Clear filters to hide search component
        this.setNavigationDocument(singleDocument)
      },
      deep: true
    }
  },
  methods: {
    getSingleResultDocument(results, groupName) {
      if (!results || !results[groupName] || results[groupName].total != 1)
        return null

      if (!results[groupName].result || results[groupName].result.length == 0)
        return null

      return results[groupName].result[0]
    },
    async selectNode(node) {
      this.selectedMainNode = node
      this.selected = node.catid
      this.path = [node.label]
      if (!this.tabNodes[this.selectedMainNode.catid].loaded)
        await this.loadChildren()

      this.searchDocuments()
    },
    valueSelected(catid, path) {
      this.path = [this.selectedMainNode.label, ...path]
      this.selected = catid

      this.searchDocuments()
    },
    async loadChildren() {
      this.onLoadingChanged(true)
      try {
        this.tabNodes[this.selectedMainNode.catid].nodes =
          await this.retrieveChildren(this.index, this.selectedMainNode.catid)
        this.tabNodes[this.selectedMainNode.catid].loaded = true
      } finally {
        this.onLoadingChanged(false)
      }
    },
    buildTabNodes() {
      return this.mainNodes.reduce((obj, node) => (
        { ...obj, [node.catid]: { nodes: [], loaded: false } }
      ), {})
    },
    searchDocuments() {
      this.setSearchType('general')
      this.setFilters([this.new_filter('clasificaciontotal', [this.selected])])
      this.performSearch()
    },
    onLoadingChanged(loading) {
      this.isLoading = loading
    },
    ...mapMutations('search', ['setFilters', 'setSearchType']),
    ...mapActions('search', ['performSearch']),
    ...mapActions('navigationIndex', ['setNavigationDocument']),
  },
  async created() {
    if (this.mainNodes.length == 0) return

    let defaultNode = this.sortedMainNodes[0]
    if (Number(this.firstNodeId) > 0) {
      defaultNode = this.mainNodes.find(n => n.catid == this.firstNodeId)
    }

    await this.selectNode(defaultNode)
  }
}
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.pe-none {
  pointer-events: none;
}
</style>
